import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';
import { media } from 'theme/utils';
import Content from 'components/Content';
import withContent from 'components/Content/withContent';

const CONTENT_KEY = 'Main Banner';
const { colors } = theme;

const Wrapper = styled.div`
  background: ${colors.primaryBlue};
  padding: 1.7em 0 2.5em;
  text-align: center;

  div[class*='descriptionWrapper'] {
    width: 19em;

    h1 {
      margin: 0.45em 0;
      color: white;
      font-size: 2.375em;
      font-weight: 800;
      line-height: 1;
      letter-spacing: -1px;
    }

    div[class*='subtitle'] {
      color: ${colors.white};
    }
  }

  ${media.md`
    padding: 2.1em 0 3.3em;

    div[class*='descriptionWrapper'] {
      width: 23em;

      h1 {
        font-size: 2.875em;
        line-height: 1.1;
      }
    }
  `}

  ${media.lg`
    padding: 4.1em 0 5.8em;

    div[class*='descriptionWrapper'] {
      width: auto;

      h1 {
        font-size: 3.4em;
        line-height: 1.3;
      }
    }
  `}
`;

const MainBanner = ({ content }) => (
  <Wrapper>
    <Content data={content} />
  </Wrapper>
);

MainBanner.propTypes = {
  content: PropTypes.object,
};

export default withContent(CONTENT_KEY)(MainBanner);
